import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';
import {
  BonusMessageTemplateRequest,
  BonusCreateRequest,
  PatchedBonusRequest
} from '@pxtra-client-lib-legacy/gen';

export const usePostBonus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      companyId,
      requestBody
    }: {
      companyId: string;
      requestBody: BonusCreateRequest;
    }) => {
      return await apiClient.bonus.bonusCreate({
        company: companyId,
        requestBody: requestBody
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bonuses'] });
    },
    onError: (error) => {
      console.error('Error creating bonus:', error);
    }
  });
};

export const usePatchBonus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      bonusId,
      requestBody
    }: {
      bonusId: string;
      requestBody: PatchedBonusRequest;
    }) => {
      return await apiClient.bonus.bonusPartialUpdate({
        id: bonusId,
        requestBody: requestBody
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bonuses'] });
    }
  });
};

export const useDeleteBonus = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { id: string }) =>
      apiClient.bonus.bonusDestroy({
        id: data.id
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bonuses'] });
    },
    ...options
  });
};

export const useCreateBonusMessageTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ template }: { template: BonusMessageTemplateRequest }) =>
      apiClient.bonus.bonusMessageTemplatesCreate({
        requestBody: template
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['message_templates']
      });
    }
  });
};

export const useUpdateBonusMessageTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, template }: { id: string; template: BonusMessageTemplateRequest }) =>
      apiClient.bonus.bonusMessageTemplatesPartialUpdate({
        id: id,
        requestBody: template
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['message_templates']
      });
    }
  });
};

export const useDeleteBonusMessageTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string }) => apiClient.bonus.bonusMessageTemplatesDestroy({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['message_templates']
      });
    }
  });
};
